/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MonitoringGridViewProtocolCancelConfirmRequest,
  MonitoringGridViewProtocolGetDetailRequest,
  MonitoringGridViewProtocolGetDetailResponse,
  MonitoringGridViewProtocolGetListResponse,
  MonitoringGridViewProtocolGetPresignedUrlRequest,
  MonitoringGridViewProtocolGetPresignedUrlResponse,
  MonitoringGridViewProtocolPostConfirmRequest,
  MonitoringGridViewProtocolPostDismissRequest,
  MonitoringMonitoringProtocolExportCsvRequest,
  MonitoringMonitoringProtocolGetChannelGroupCountResponse,
  MonitoringMonitoringProtocolGetListingCountResponse,
  MonitoringMonitoringProtocolGetMonitoringCountRequest,
  MonitoringMonitoringProtocolGetMonitoringListRequest,
  MonitoringMonitoringProtocolGetStatusCountRequest,
  MonitoringMonitoringProtocolGetStatusCountResponse,
  MonitoringMonitoringProtocolGetWebsiteFilterRequest,
  MonitoringMonitoringProtocolGetWebsiteFilterResponse,
  MonitoringTableViewProtocolCancelConfirmRequest,
  MonitoringTableViewProtocolGetListResponse,
  MonitoringTableViewProtocolPostConfirmRequest,
  MonitoringTableViewProtocolPostDismissRequest,
  PiracyCommonProtocolFileResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Monitoring<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Monitoring
   * @name ChannelGroupCountList
   * @request GET:/monitoring/channel_group_count
   */
  channelGroupCountList = (params: RequestParams = {}) =>
    this.http.request<MonitoringMonitoringProtocolGetChannelGroupCountResponse, any>({
      path: `/monitoring/channel_group_count`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Monitoring
   * @name StatusCountCreate
   * @request POST:/monitoring/status_count
   */
  statusCountCreate = (data: MonitoringMonitoringProtocolGetStatusCountRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringMonitoringProtocolGetStatusCountResponse, any>({
      path: `/monitoring/status_count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Monitoring
   * @name ListingCountCreate
   * @request POST:/monitoring/listing_count
   */
  listingCountCreate = (data: MonitoringMonitoringProtocolGetMonitoringCountRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringMonitoringProtocolGetListingCountResponse, any>({
      path: `/monitoring/listing_count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Monitoring
   * @name FilterWebsiteCreate
   * @request POST:/monitoring/filter/website
   */
  filterWebsiteCreate = (data: MonitoringMonitoringProtocolGetWebsiteFilterRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringMonitoringProtocolGetWebsiteFilterResponse, any>({
      path: `/monitoring/filter/website`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Monitoring
   * @name ExportCsvCreate
   * @request POST:/monitoring/export_csv
   */
  exportCsvCreate = (data: MonitoringMonitoringProtocolExportCsvRequest, params: RequestParams = {}) =>
    this.http.request<PiracyCommonProtocolFileResponse, any>({
      path: `/monitoring/export_csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Monitoring
   * @name TableListCreate
   * @request POST:/monitoring/table/list
   */
  tableListCreate = (data: MonitoringMonitoringProtocolGetMonitoringListRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringTableViewProtocolGetListResponse, any>({
      path: `/monitoring/table/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Monitoring
   * @name TableConfirmCreate
   * @request POST:/monitoring/table/confirm
   */
  tableConfirmCreate = (data: MonitoringTableViewProtocolPostConfirmRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/monitoring/table/confirm`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Monitoring
   * @name TableDismissCreate
   * @request POST:/monitoring/table/dismiss
   */
  tableDismissCreate = (data: MonitoringTableViewProtocolPostDismissRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/monitoring/table/dismiss`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Monitoring
   * @name TableCancelConfirmCreate
   * @request POST:/monitoring/table/cancel-confirm
   */
  tableCancelConfirmCreate = (data: MonitoringTableViewProtocolCancelConfirmRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/monitoring/table/cancel-confirm`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Monitoring
   * @name GridListCreate
   * @request POST:/monitoring/grid/list
   */
  gridListCreate = (data: MonitoringMonitoringProtocolGetMonitoringListRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringGridViewProtocolGetListResponse, any>({
      path: `/monitoring/grid/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Monitoring
   * @name GridDetailCreate
   * @request POST:/monitoring/grid/detail
   */
  gridDetailCreate = (data: MonitoringGridViewProtocolGetDetailRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringGridViewProtocolGetDetailResponse, any>({
      path: `/monitoring/grid/detail`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Monitoring
   * @name GridConfirmCreate
   * @request POST:/monitoring/grid/confirm
   */
  gridConfirmCreate = (data: MonitoringGridViewProtocolPostConfirmRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/monitoring/grid/confirm`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Monitoring
   * @name GridNotePresignedCreate
   * @request POST:/monitoring/grid/note/presigned
   */
  gridNotePresignedCreate = (data: MonitoringGridViewProtocolGetPresignedUrlRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringGridViewProtocolGetPresignedUrlResponse, any>({
      path: `/monitoring/grid/note/presigned`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Monitoring
   * @name GridDismissCreate
   * @request POST:/monitoring/grid/dismiss
   */
  gridDismissCreate = (data: MonitoringGridViewProtocolPostDismissRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/monitoring/grid/dismiss`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Monitoring
   * @name GridCancelConfirmCreate
   * @request POST:/monitoring/grid/cancel-confirm
   */
  gridCancelConfirmCreate = (data: MonitoringGridViewProtocolCancelConfirmRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/monitoring/grid/cancel-confirm`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
